import React from 'react';
import { QuoteFormBaseInputsBlock } from './blocks/quoteFormBaseInputsBlock';
import { QuoteFormErrorInfoBlock } from './blocks/quoteFormErrorInfoBlock';
import { QuoteFormComplementaryInputsBlock } from './blocks/quoteFormComplementaryInputsBlock';

const QuoteFormBody = ({ quoteFormBodyData }) => {
  const { backendErrors } = quoteFormBodyData;
  const hasBackendErrors = Object.keys(backendErrors).length > 0;
  let backendErrorsMsg = 'There was an error creating the quote';
  if (backendErrors.details === 'can_not_reach_backend')
    backendErrorsMsg = 'There was an error connecting to the server';
  return (
    <>
      <QuoteFormBaseInputsBlock quoteFormBodyData={quoteFormBodyData} />
      <QuoteFormComplementaryInputsBlock quoteFormBodyData={quoteFormBodyData} />
      {hasBackendErrors && <QuoteFormErrorInfoBlock backendErrorsMsg={backendErrorsMsg} />}
    </>
  );
};

export default QuoteFormBody;
